import React from 'react';
import useOrganizationGroups from '../../../../../../hooks/api/useOrganizationGroups';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { SideDrawerContentContainer } from '../../../../../v2BaseComponents/SideDrawer';
import GroupDetails from '../../../../../shared/Groups/GroupDetails';

export type GroupDetailsDrawerContentOwnProps = {
    groupId: string;
};

export type GroupDetailsDrawerContentProps = GroupDetailsDrawerContentOwnProps;

const GroupDetailsDrawerContent: React.FC<GroupDetailsDrawerContentProps> = ({ groupId }) => {
    const { group, isLoadingGroup } = useOrganizationGroups({
        groupId: groupId,
    });

    return (
        <AnimateLoadedContent isLoading={isLoadingGroup || !group}>
            {() => (
                <SideDrawerContentContainer>
                    <GroupDetails group={group!} />
                </SideDrawerContentContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(GroupDetailsDrawerContent);
